import { redirect } from '@sveltejs/kit'
import type { LayoutLoad } from './$types'
import { getAccountMutationCompletionRedirectPath } from '$lib/routing/auth-routing.js'
import { bootstrapAppRuntime } from '$lib/runtime/app-runtime.js'

export const ssr = false

export const load: LayoutLoad = async ({ url }) => {
    const { appServices } = await bootstrapAppRuntime()
    const accountMutationRedirect = getAccountMutationCompletionRedirectPath(
        appServices.auth.state
    )

    if (accountMutationRedirect && url.pathname !== accountMutationRedirect) {
        redirect(307, accountMutationRedirect)
    }

    return {
        appVersion: __APP_VERSION__
    }
}
